import { useParams } from 'react-router-dom'

import {
  ShowPageDocument,
  ShowPageFieldsDocument,
  TasksValueObjectsTaskIdentifierEnum,
} from 'generated/resources/graphql'
import compact from 'lodash/compact'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import TaskElement from 'modules/tasks/components/TaskElement'

const ShowPage = () => {
  const params = useParams()
  const { taskId, identifier } = params
  const { navigation } = useNavigation()
  const back = navigation.tasks.fullPath()

  const { data, loading } = useQuery(ShowPageDocument, {
    variables: {
      taskId: String(taskId),
    },
  })

  const affecteeEmployeeId =
    data?.tasks.tasksConnection.edges[0]?.node?.affecteesConnection.edges[0]?.node?.employee?.id

  const { data: fieldsData, loading: fieldsLoading } = useQuery(ShowPageFieldsDocument, {
    variables: {
      relatedEmployeeId: affecteeEmployeeId,
    },
    skip: !affecteeEmployeeId,
  })

  const canEmployeeManageAnyEmployeeFolder =
    data?.documents._policies.employeeManageAnyEmployeeFolder.can ?? false

  const customResourceFieldsData =
    compact(fieldsData?.customFields.resourceFieldsConnection.edges.map((edge) => edge.node)) ?? []

  const customValuesData =
    data?.tasks.tasksConnection.edges[0]?.node?.affecteesConnection.edges[0]?.node?.employee?.valuesConnection.edges.map(
      (edge) => edge.node
    ) ?? []

  return (
    <TaskElement
      identifier={identifier as TasksValueObjectsTaskIdentifierEnum} // eslint-disable-line no-type-assertion/no-type-assertion
      taskId={String(taskId)}
      back={back}
      canEmployeeManageAnyEmployeeFolder={canEmployeeManageAnyEmployeeFolder}
      loading={loading || fieldsLoading}
      customResourceFieldsData={customResourceFieldsData}
      customValuesData={customValuesData}
    />
  )
}

export default ShowPage
